<template>
  <div class="seeInfo">
    <div class="breadcrumb">
      <div @click="toHome">新闻资讯</div>
      <img src="../../../../../assets/channel/login/info.png" alt="">
      <div style="color: #00266d;">资讯详情</div>
    </div>
    <div class="Info">
      <div class="Title">
        {{InformationInfoListprops.Title}}
      </div>
      <div class="time">{{ InformationInfoListprops.CreateTime }}</div>
      <div class="line1">|</div>
      <div class="name">{{ InformationInfoListprops.CreatorName }}</div>

      <div class="line2"></div>

      <div class="text">
       {{ InformationInfoListprops.InfoContent }}
      </div>
      <div class="line3"></div>
      <div>
        <CommUploadAdditional width="550px" backgroundColor="#FAFBFC" :fileData="InformationInfoListprops.Attachments" :srcleft="require('@/assets/channel/icon-FJ.png')" @DowloadFile="DowloadFileSeeInfo"></CommUploadAdditional>
      </div>
    </div>
  </div>
</template>

<script>
import CommUploadAdditional from '../../../../../components/comm-upload-additional.vue'
export default {
  components: {
    CommUploadAdditional
  },
  props: {
    InformationInfoListprops: {
      type: Object,
    }
  },
  data() {
    return {
    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    toHome() {
      this.$emit("toHome")
    },
    // 下载文件
    DowloadFileSeeInfo() {

    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.breadcrumb {
  width: 1200px;
  //   border: 1px solid red;
  margin: 0 auto;
  position: relative;
  top: 19px;
  margin-bottom: 41px;
  div:nth-child(1):hover {
    color: #e71d43;
  }

  img {
    position: relative;
    top: 3px;
    margin-left: 10px;
    margin-right: 10px;
  }
  div:nth-child(1) {
    color: #9ca5b8;
  }

  div {
    font-size: 14px;
    font-weight: 500;
    display: inline-block;
    cursor: pointer;
  }
}
.Info {
  width: 1140px;
  min-height: 440px;
  height: 100%;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ebedf0;
  margin: 0 auto 50px auto;
  padding: 30px;

  .Title {
    font-weight: 500;
    color: #16181a;
    font-size: 24px;
  }
  .time {
    display: inline-block;
    font-size: 14px;
    color: #9ca5b8;
    margin-top: 6px;
  }
  .line1 {
    display: inline-block;
    font-size: 14px;
    color: #9ca5b8;
    margin-top: 6px;
    margin-left: 16px;
  }
  .line2 {
    width: 100%;
    height: 1px;
    background-color: #f2f3f5;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .name {
    display: inline-block;
    font-size: 14px;
    color: #9ca5b8;
    margin-top: 6px;
    margin-left: 16px;
  }
  .text {
    width: 100%;
    font-weight: 400;
    color: #424e66;
    line-height: 22px;
    font-size: 16px;
    white-space: pre-wrap;
  }
}
.line3 {
  height: 1px;
  width: 100%;
  background-color: #f2f3f5;
  margin-top: 48px;
  margin-bottom: 32px;
}
p {
  margin-top: 40px;
}
</style>